import { render, staticRenderFns } from "./CreateReference.vue?vue&type=template&id=202e352c&scoped=true&"
import script from "./CreateReference.vue?vue&type=script&lang=js&"
export * from "./CreateReference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202e352c",
  null
  
)

export default component.exports